module.exports = __webpack_public_path__ + "img/banner3.d849e8b9.png";